import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {useStorage} from "@/api/storage/local";

// Equipment quiz answers, kept in storage per user id
export type QuizEquipmentModel = Record<string, unknown>

export interface QuizEquipmentState {
    model: QuizEquipmentModel
}

const STORAGE_KEY = "quiz_equipment";

const equipment: Module<QuizEquipmentState, RootState> = {
    namespaced: true,
    state: {
        model: {}
    },
    getters: {
        model: (state): QuizEquipmentModel => state.model,
        storage: () => (userId: string): QuizEquipmentModel | undefined => useStorage()!.get(STORAGE_KEY, {})[userId]
    },
    mutations: {
        setModel: (state, model: QuizEquipmentModel) => state.model = model
    },
    actions: {
        // Without a model, loads the one saved in storage for the current user
        fetch(context, model?: QuizEquipmentModel) {

            if ("undefined" === typeof model) {

                const storage = useStorage()!;
                const userId = context.rootGetters["user/id"];

                model = storage.get(STORAGE_KEY) && storage.get(STORAGE_KEY)[userId]
                    ? storage.get(STORAGE_KEY)[userId]
                    : {};
            }

            context.commit("setModel", model);
        },
        setModel(context, model: QuizEquipmentModel) {

            context.commit("setModel", model);
            context.dispatch("updateStorage");
        },
        clear(context) {

            context.commit("setModel", {});
            context.dispatch("updateStorage");
        },
        updateStorage(context) {

            const storage = useStorage()!;
            const result = storage.get(STORAGE_KEY, {});

            storage.set(STORAGE_KEY, {
                ...result,
                [context.rootGetters["user/id"]]: context.state.model
            })
        },
    }
}

export default equipment
